import React from 'react'
import styled from '@emotion/styled'

import { BlockMonogramInverse } from '../svgs/BlockMonogramInverse'
import { CustomerServiceHeadset } from '../svgs/CustomerServiceHeadset'
import { DatalotPhoneIcon } from '../svgs/DatalotPhoneIcon'
import { Button } from '@jelly/ui'

const DatalotbannerWrapper = styled.div`
	background-image: linear-gradient(to bottom, #029bb6 0%, #126898 100%);
	display: flex;
	flex-direction: column;
	margin-bottom: 40px;
	margin-top: 40px;
	min-height: 270px;
	overflow: hidden;
	padding: 1.5rem 1.25rem;
	position: relative;
	width: 100%;
	z-index: 1;

	${({ theme }) => theme.MQ.XL} {
		background-image: linear-gradient(to left, #029bb6 0%, #126898 100%);
		font-size: 24px;
		flex-direction: row;
		margin-top: 0px;
		margin-bottom: 00px;
	}
`
const Bannerh1 = styled.h1`
	color: #ffffff;
	font-size: 2rem;
	letter-spacing: -0.26px;
	line-height: 34px;
	margin: 0;
	padding-right: 20%;
	width: 80%;

	@media (min-width: 350px) {
		width: 100%;
	}

	${({ theme }) => theme.MQ.XL} {
		margin: 0;
		padding: 0;
	}
`

const BannerP = styled.div`
	color: #ffffff;
	font-size: 18px;
	margin: 2rem 0;
	width: 90%;

	${({ theme }) => theme.MQ.XL} {
		font-size: 18px;
		width: 100%;
	}
`

const HeadsetContainer = styled.div`
	bottom: 0px;
	fill: #ffffff;
	height: 100%;
	opacity: 0.2;
	position: absolute;
	right: 0px;
	transform: translate(20%, 20%);
	width: 100%;
	z-index: -1;

	${({ theme }) => theme.MQ.XL} {
		height: 380px;
		left: 50%;
		top: 50%;
		transform: translate(-10%, -35%);
		width: 400px;
	}

	${({ theme }) => theme.MQ.XL} {
		height: 380px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -40%);
		width: 400px;
	}
`

const ButtonContainer = styled.div`
	padding: 5% 5% 0 5%;
	width: 100%;
`

const CallText = styled.p`
	align-self: center !important;
	color: #a6daf7 !important;
	font-size: 18px;
	line-height: 48px;
	margin: -8px 0 !important;
	text-align: center;
`

const PhoneNum = styled.span`
	font-size: 18px;
	padding-left: 8px;
`

const LeftContainer = styled.div`
	padding-left: 0;
	width: 100%;
	${({ theme }) => theme.MQ.XL} {
		padding-left: 3%;
	}
`

const RightContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-bottom: 2%;
	width: 100%;

	${({ theme }) => theme.MQ.XL} {
		justify-content: flex-end;
		padding-bottom: 6%;
		padding-left: 10%;
	}
`

const BlockMongogramContainer = styled.div`
	fill: #029bb6;
	position: absolute;
	right: 0px;
	top: 0px;
`

export function DatalotBanner() {
	return (
		<DatalotbannerWrapper>
			<LeftContainer>
				<Bannerh1>Need help choosing an insurance provider?</Bannerh1>
				<BannerP>
					Speak to a USA-based licensed agent for help navigating your insurance options and comparing the
					plans that best meet your needs.
				</BannerP>
			</LeftContainer>

			<RightContainer>
				<CallText>Call anytime 24/7:</CallText>
				<ButtonContainer>
					<a href="tel:8887843754">
						<Button style={{ maxWidth: '100%' }}>
							<DatalotPhoneIcon width="20px" height="26px" />
							<PhoneNum> 888-784-3754</PhoneNum>
						</Button>
					</a>
				</ButtonContainer>
			</RightContainer>
			<BlockMongogramContainer>
				<BlockMonogramInverse />
			</BlockMongogramContainer>
			<HeadsetContainer>
				<CustomerServiceHeadset />
			</HeadsetContainer>
		</DatalotbannerWrapper>
	)
}
